import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

import { getClassNameOverride } from '~/chords/getClassNameOverride';
import { cn } from '~/chords/lib/cn';
import { Scrollbars } from '~/chords/Scrollbars';

import type { SlideOutBodyProps } from '../types';

export const SlideOutBody = forwardRef<HTMLDivElement, SlideOutBodyProps>(
  ({ children, scrollable = true, ...props }, ref) => {
    const className = getClassNameOverride(props, 'SlideOut.Body');

    const content = (
      <div
        className={cn(
          'h-full grow overflow-y-auto overscroll-y-contain px-lg py-md',
          className,
        )}
      >
        {children}
      </div>
    );

    return (
      <Dialog.Description ref={ref} {...props} asChild>
        {scrollable ? <Scrollbars asChild>{content}</Scrollbars> : content}
      </Dialog.Description>
    );
  },
);

SlideOutBody.displayName = 'SlideOut.Body';
